module.exports = __webpack_public_path__ + "img/cityteam-international.6f8627f9.jpg";